angular
    .module('festzelt-os.documents.templates')
    .factory('editDocumentTemplate', [
        '$injector',
        ($injector) => new EditDocumentTemplateWorkflow($injector)
    ]);

class EditDocumentTemplateWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');

        this.level = 'highlight';
        this.order = 10;
        this.title = this.translate.instant('general.verbs.edit');
        this.icon = 'pencil';
        this.key = 'edit-document-template';
    }

    action(documentTemplate, vm) {
        this.state.go('app.documents.templates.edit', {id: documentTemplate.id});
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/workflows/details/edit-template.js